import { useCallback, useEffect, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { useAppSelector } from '@/store'
import {
  removeGingivaStainingTarget,
  setGingivaRecipeOutput,
} from '@/store/stainingStudio'

import GingivaStainingTooltip from './components/GingivaStainingTooltip'

const KonvaGingivaStaining = () => {
  const dispatch = useAppDispatch()
  const gingivaStaing = useAppSelector(
    (state) => state.stainingStudio.gingivaStaing,
  )
  const gingivaRecipeOutput = useAppSelector(
    (state) => state.stainingStudio.gingivaRecipeOutput,
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )

  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}
    Object.keys(gingivaStaing?.[canvasImage?.id] || {}).forEach((key) => {
      initialTooltipState[key] = true
    })
    setTooltipOpenMap(initialTooltipState)
  }, [gingivaStaing, canvasImage?.id])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteGingiva = useCallback(
    (regionKey: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setGingivaRecipeOutput({
          imageId: canvasImage?.id,
          key: regionKey,
          result: undefined,
        }),
      )
      dispatch(
        removeGingivaStainingTarget({
          imageId: canvasImage?.id,
          key: regionKey,
        }),
      )
    },
    [dispatch, canvasImage?.id],
  )
  return (
    <>
      {Object.keys(gingivaStaing?.[canvasImage?.id] || {}).map((key) => {
        const data = gingivaStaing?.[canvasImage?.id]?.[key]
        const output = gingivaRecipeOutput?.[canvasImage?.id]?.[key]

        if (!data?.output || !output) return null

        return (
          <GingivaStainingTooltip
            key={key}
            keyName={key}
            data={data}
            output={output}
            open={!!tooltipOpenMap[key]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            onDelete={handleDeleteGingiva}
          />
        )
      })}
    </>
  )
}

export default KonvaGingivaStaining
